// Module
var code = `<table class="table no-print history" ng-table="\$ctrl.tableConfig">
  <thead>
  <tr>
    <th>No</th>
    <th>Date Printed</th>
    <th>Letter Type</th>
    <th>Earliest Amortization on Due</th>
    <th>Executed by</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="item in \$data">
    <td>{{\$index+1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}} </td>
    <td>{{item.registrationTime | prettyDateTime }}</td>
    <td>{{item.letterType.name}}</td>
    <td>{{item.amortizationNumber}}</td>
    <td>{{\$ctrl.getUserEffectiveName(item.printedBy)}}</td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/loan-letter-history/loan-letter-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;